import { ExpenseData } from '../types';

export const expenseData: ExpenseData[] = [
  {
    category: "Labor",
    total: 346646.13,
    locations: {
      "Overhead": 27662.94,
      "Morristown": 72462.52,
      "Bean Station": 17805.76,
      "New Tazewell": 20872.71,
      "Maryville": 37205.10,
      "Newport": 18866.15,
      "Rogersville": 38866.10,
      "Jefferson City": 44265.07,
      "Admin": 35137.46,
      "Billing": 19162.21,
      "Marketing": 14340.09
    }
  },
  {
    category: "Occupancy",
    total: 51850.00,
    locations: {
      "Overhead": 0.00,
      "Morristown": 18500.00,
      "Bean Station": 5000.00,
      "New Tazewell": 4000.00,
      "Maryville": 4500.00,
      "Newport": 3000.00,
      "Rogersville": 5750.00,
      "Jefferson City": 11100.00,
      "Admin": 0.00,
      "Billing": 0.00,
      "Marketing": 0.00
    }
  },
  {
    category: "Office Expenses",
    total: 18156.26,
    locations: {
      "Overhead": 12610.83,
      "Morristown": 1574.41,
      "Bean Station": 832.15,
      "New Tazewell": 97.05,
      "Maryville": 97.05,
      "Newport": 731.55,
      "Rogersville": 1223.17,
      "Jefferson City": 990.06,
      "Admin": 0.00,
      "Billing": 0.00,
      "Marketing": 0.00
    }
  },
  {
    category: "Utilities",
    total: 5621.06,
    locations: {
      "Overhead": 0.00,
      "Morristown": 1560.00,
      "Bean Station": 410.00,
      "New Tazewell": 461.76,
      "Maryville": 804.54,
      "Newport": 625.00,
      "Rogersville": 888.76,
      "Jefferson City": 871.00,
      "Admin": 0.00,
      "Billing": 0.00,
      "Marketing": 0.00
    }
  },
  {
    category: "Marketing",
    total: 12000.00,
    locations: {
      "Overhead": 12000.00,
      "Morristown": 0.00,
      "Bean Station": 0.00,
      "New Tazewell": 0.00,
      "Maryville": 0.00,
      "Newport": 0.00,
      "Rogersville": 0.00,
      "Jefferson City": 0.00,
      "Admin": 0.00,
      "Billing": 0.00,
      "Marketing": 0.00
    }
  },
  {
    category: "Insurance",
    total: 7405.91,
    locations: {
      "Overhead": 7405.91,
      "Morristown": 0.00,
      "Bean Station": 0.00,
      "New Tazewell": 0.00,
      "Maryville": 0.00,
      "Newport": 0.00,
      "Rogersville": 0.00,
      "Jefferson City": 0.00,
      "Admin": 0.00,
      "Billing": 0.00,
      "Marketing": 0.00
    }
  },
  {
    category: "EMR Software",
    total: 9218.33,
    locations: {
      "Overhead": 9218.33,
      "Morristown": 0.00,
      "Bean Station": 0.00,
      "New Tazewell": 0.00,
      "Maryville": 0.00,
      "Newport": 0.00,
      "Rogersville": 0.00,
      "Jefferson City": 0.00,
      "Admin": 0.00,
      "Billing": 0.00,
      "Marketing": 0.00
    }
  },
  {
    category: "Other Expenses",
    total: 81259.48,
    locations: {
      "Overhead": 69748.98,
      "Morristown": 6692.94,
      "Bean Station": 303.00,
      "New Tazewell": 0.00,
      "Maryville": 185.00,
      "Newport": 2156.57,
      "Rogersville": 0.00,
      "Jefferson City": 0.00,
      "Admin": 173.00,
      "Billing": 0.00,
      "Marketing": 0.00
    }
  }
];

export const totalExpenses = {
  total: 580838.67,
  locations: {
    "Overhead": 188595.24,
    "Morristown": 100071.63,
    "Bean Station": 24350.91,
    "New Tazewell": 25431.52,
    "Maryville": 42791.69,
    "Newport": 23379.27,
    "Rogersville": 48092.18,
    "Jefferson City": 61753.47,
    "Admin": 35390.46,
    "Billing": 19162.21,
    "Marketing": 14340.09
  }
};

export const loanPayback = {
  total: 48681.50,
  locations: {
    "Overhead": 37948.26,
    "Morristown": 4841.76,
    "Bean Station": 0.00,
    "New Tazewell": 0.00,
    "Maryville": 0.00,
    "Newport": 0.00,
    "Rogersville": 1364.15,
    "Jefferson City": 4527.33,
    "Admin": 0.00,
    "Billing": 0.00,
    "Marketing": 0.00
  }
};